import { createRouter, createWebHistory } from 'vue-router';
import routes from './routes';
import { useUserStore } from '@/stores/user';
import { storeToRefs } from 'pinia';
import { clearRedirectPath, loadRedirectPath, storeRedirectPath } from '@/redirect-path';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: routes,
});

router.beforeEach(async (to, from) => {  
  const userStore = useUserStore();
  const { fetchUser, signin } = userStore;
  await fetchUser();
  
  const { user, role } = storeToRefs(userStore);

  if (user.value === null) {
    storeRedirectPath(to.fullPath);
    await signin();
    return false;
  }

  if (to.meta.roles && Array.isArray(to.meta.roles) && !to.meta.roles.includes(role.value)) {
    return { name: 'forbidden' };
  }

  const redirectUri = loadRedirectPath();

  if (redirectUri !== null) {
    clearRedirectPath();
    return redirectUri;
  }

  document.title = to.meta.title?.toString() ?? 'Workflow';
});

router.afterEach(() => {
  window.scrollTo(0, 0);
});

export default router;
